import React, { createContext, useMemo, useState } from "react";
import RistaLoyalty from ".";

export const defaultContextState = {
  onSuccess: () => { },
  onCancel: () => { },
  updateCallbacks: () => { },
  setLoyaltyModal: () => { },
  resetCallbacks: () => { },
};

type loyaltyModalContextType = {
  onSuccess: Function;
  onCancel: Function;
  updateCallbacks: Function;
  resetCallbacks: Function;
  setLoyaltyModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LoyaltyModalContext = createContext<loyaltyModalContextType>(
  defaultContextState
);

const CustomLoyaltyContextProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const [callbacks, setCallbacks] = useState<{
    onSuccess: Function;
    onCancel: Function;
  }>(
    defaultContextState
  );
  const [loyaltyModal, setLoyaltyModal] = useState(false);
  const value = useMemo(
    () => ({
      onSuccess: callbacks.onSuccess,
      onCancel: callbacks.onCancel,
      updateCallbacks: setCallbacks,
      setLoyaltyModal,
      resetCallbacks: () => {
        setCallbacks({ onSuccess: () => { }, onCancel: () => { } })
      }
    }),
    [callbacks]
  );

  return (
    <LoyaltyModalContext.Provider value={value}>
      {children}
      {loyaltyModal && <RistaLoyalty />}
    </LoyaltyModalContext.Provider>
  );
};

export default CustomLoyaltyContextProvider;
